import axios from "axios";
import router from '../router'
import Vue from 'vue'

//创建一个axios实例
const service = axios.create({
  baseURL: g.baseURL,
  timeout: 5000
});

//请求拦截
service.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    // 跳转error页面
    router.push({
      path: "/notFound"
    });
    return Promise.reject(error);
  }
);

//响应拦截
service.interceptors.response.use(
  res => {
    if (res.data.code * 1 != 0) {
      Vue.prototype.$message({
        message: res.data.msg,
        type: 'error'
      });
      // 跳转error页面
      router.push({
        path: "/notFound"
      });
    }

    return res.data;
  },
  error => {
    // 跳转error页面
    router.push({
      path: "/notFound"
    });
    return Promise.reject(error);
  }
);


export default service;